import { USER_ACCESS_LEVEL } from './constants';

/**
 * Unique key for the active portal session's workspace context.
 * A user may hold several memberships; switching owner → peer or client can
 * change role and/or dq_insider_id — branding must refetch on every switch,
 * not only when dq_insider_id changes.
 */
export function getBrandingSessionKey(authUser) {
    if (!authUser || !authUser.dq_insider_id) return '';

    const role = authUser.is_peer === true
        ? 'peer'
        : (authUser.access_level === USER_ACCESS_LEVEL.PARTIAL_ACCESS_DQ_INSIDER_PORTAL_SINGLE_INSTITUTE
            ? 'client'
            : 'owner');

    /*
     * institute_code is part of the identity, not decoration: every school in
     * a network shares one org_code AND one dq_insider_id, and they all resolve
     * to the same role, so without it two sibling schools produce the SAME key
     * and a switch between them would not read as a workspace change.
     */
    return `${authUser.dq_insider_id}::${role}::${authUser.org_code || ''}::${authUser.institute_code || ''}`;
}

export default getBrandingSessionKey;
